import axios from 'axios';
import { createContext, useCallback, useContext, useState } from 'react';
import { useAuth } from './AuthContext';

const TrainingContext = createContext(null);

export const TrainingProvider = ({ children }) => {

  const { user } = useAuth();
  const [getAlert, setGetAlert] = useState(null);
  const [modules, setModules] = useState([]);

  const getTrainingModules = useCallback(async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}api/v1/posp-profile/${user?.id}/`
    );

    if (response.data.success) {
      setModules(response.data.data);
    }else{
      setGetAlert({ type: 'warning', message: "Sorry! Coudn't fetch Training Module. Please Logout and Try Again." });
    }
  } catch (error) {
    console.error(error);
    setGetAlert({ type: 'warning', message: "Sorry! Coudn't fetch Training Module. Please Logout and Try Again." });
  }
}, [user?.id]);

  const updateProgressOnBackend = useCallback(async (moduleId, completionMinutes) => {
    if (!user?.id || !modules) return;

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}api/v1/posp-training-update/${moduleId}/`,
        {
          completion_minutes: completionMinutes,
        }
      );

      if (response.data.success) {
        setModules(response.data.data);
      }else{
        setGetAlert({ type: 'warning', message: "Sorry! There's an error in Updating Progress" });
      }
    } catch (error) {
      console.error("Error updating progress on backend:", error);
      setGetAlert({ type: 'warning', message: "Sorry! There's an error in Updating Progress" });
    }
  }, [user?.id, modules]);

  const overallProgress = useCallback(() => {
    const trainings = modules?.trainings || [];
    if (trainings.length === 0) return 0;
    const total = trainings.reduce((sum, mod) => {
      const percentage = mod?.duration_minutes
        ? Math.min(
            100,
            Math.round(
              (mod.completion_minutes / mod.duration_minutes) * 100
            )
          )
        : 0;
      return sum + percentage;
    }, 0);
    return Math.round(total / trainings.length);
  }, [modules]);

  return (
    <TrainingContext.Provider value={{ getAlert,setGetAlert, modules, overallProgress, getTrainingModules, updateProgressOnBackend }}>
      {children}
    </TrainingContext.Provider>
  );
};

export const useTraining = () => useContext(TrainingContext);
